/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateUserPasswordForm { 
    /**
     * Token fornito tramite email. Non può essere nullo o vuoto.
     */
    token: string;
    /**
     * Password dell\'utente. Non può essere nullo o vuoto.
     */
    password: string;
}

